import type { FC } from 'react';
import ChordChart from '../../../components/charts/chord-chart.js';

interface Props {
  data: Item[];
}

export interface Item {
  source: string;
  target: string;
  value: number;
}

export const ChartView: FC<Props> = ({ data }) => (
  <ChordChart data={data} size={500} />
);
